module.exports = __webpack_public_path__ + "img/10.88929be4.jpg";